<template>
  <div class="header-wrap">
    <h1 class="title ">开通潮国VIP会员 尊享每日独家设计</h1>
    <div class="identify-box ">
      <div class="identify-item">
        <i class="icon_shang"/>
        畅享正版商用授权
      </div>
      <div class="identify-item">
        <i class="icon_zuan"/>
        专属VIP身份标识
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderWrap"
}
</script>

<style lang="scss" scoped>

._opacity{
  opacity: 0;
}

.header-wrap {
  @include BgImage(100%, 586px, 'introduce/introduce-bg.jpg', 1);
  //@include BgImage(100%, 586px, 'act/new-year/new-year%40bg.jpg', 1);
  text-align: center;

  .title {
    font-size: 48px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 64px;
    letter-spacing: 2px;
    margin-bottom: 14px;
    padding-top: 68px;
  }

  .identify-box {
    display: flex;
    align-items: center;
    justify-content: center;

    .identify-item {
      margin-right: 40px;
      font-size: 18px;
      color: #384170;
      line-height: 24px;
      letter-spacing: 1px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }

      i {
        margin-right: 8px;

        &.icon_shang {
          @include BgImage(20px, 22px, 'introduce/icon_shang.png')
        }

        &.icon_zuan {
          @include BgImage(20px, 22px, 'introduce/icon_zuan.png')
        }
      }
    }


  }
}
</style>
